import debug from 'debug'
import { isBrowser } from './is.browser'

const logger = debug('localstorage')

export const allowStorage = (): boolean => {
  if (!isBrowser()) {
    return false
  }

  try {
    if (localStorage) {
      return true
    }
  } catch (e) {
    logger('no localstorage available!!')
  }

  return false
}
